import { useRef, useEffect } from 'react'


function useOutsideAlerter(ref, onClickOutside) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        event.stopPropagation()
        onClickOutside()
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref])
}

/**
 * Component that alerts if you click outside of it
 */
export default function OutsideAlerter({
  children,
  onClickOutside,
  className,
}) {
  const wrapperRef = useRef(null)
  useOutsideAlerter(wrapperRef, onClickOutside)

  return (
    <div ref={wrapperRef} className={className}>
      {children}
    </div>
  )
}
